/*global $Ap, AddPerson, JSON, PersonCard, acom, addPersonUrl, console, jQuery, location, window */
/****************************************
	add-person.js
*****************************************/
var AddPerson = (function ($) {
	'use strict';
	var loadCacheFiles = function (response) {
		var filesToLoad = [],
			deferred = new $.Deferred();
		if (AddPerson.cacheLoaded) {
			deferred.resolve(true);
		} else {
			/* Load AddPerson Stylesheets */
			/* We don't want to load in multiple css files */
			$('.add-person-css').remove();
			$.each(response.css, function (ignore, css) {
				$('head').append('<link class="add-person-css" rel="stylesheet" href="' + css + '" type="text/css" />');
			});
			/* Load AddPerson Scripts */
			$.each(response.js, function (ignore, js) {
				var def = new $.Deferred();
				$.ajax({
					dataType: 'script',
					cache: true,
					url: js,
					crossDomain: true,
					success: function () {
						def.resolve(true);
					},
					failure: function () {
						deferred.reject(js);
					}
				});
				filesToLoad.push(def);
			});
			$.when.apply($, filesToLoad).done(function () {
				deferred.resolve(true);
			});
		}
		return deferred;
	};
	var _addPerson = {
		cacheLoaded: false,
		/* this apmDefCallback (the lowest level callback), is to be used for screen refresh, modal close, and redirecting to a new page, or back to a modal */
		apmDefCallback: function (cbResponse) {
			if (cbResponse.mode === "m") {
				$.modal.close();
			} else if (!window.isCancelClicked) {
				location.reload();
			}
		},
		/* this apsCallback (the mid-level callback), is to be used for notifications to the user, and does it's work before the final callback */
		apsCallback: function (cbResponse) {
			if (cbResponse.newPid !== null && cbResponse.status !== null) {
				if (cbResponse.status === "success") {
					if (window.personScreenType('smart-phone')) {
						window.glue.reload({ "responsiveTab": "family" });
					} else {
						window.glue.reload();
					}
					/* Show success Growl notification */
					if (acom !== null && acom.bus !== null) {
						acom.bus.emit('AddPerson::Notify::Success', cbResponse.message, cbResponse.title, true);
					}
				} else if (cbResponse.status === "failure") {
					/* Show failure Growl notification */
					if (acom !== null && acom.bus !== null) {
						acom.bus.emit('AddPerson::Notify::Failure', cbResponse.message, cbResponse.title);
					}
				}
			}
			return (typeof (AddPerson.apmCallback) === "function") ? AddPerson.apmCallback(cbResponse) : AddPerson.apmDefCallback(cbResponse);
		},
		Modal: function (tid, pid, args, apmCallback, type, trigger) {
			var url = addPersonUrl + '/modals/addPerson/tree/' + tid + '/person/' + pid;
			if (type === "edit") {
				url += '/edit';
			}
			var params = {};
			if (typeof (args) === 'object') {
				params = args;
			} else if (typeof (args) === 'string') {
				params = JSON.parse(args);
			}
			params.useNewVersion = "5";
			params.isPageVersion = false;
			$('<div id="AddPersonModal"></div>').modal({
				'showLoading': true,
				'hideCloseBtn': false,
				'useCustomPadding': true,
				'closeOnBkgClick': true,
				'closeOnEscape': true,
				'isMarketing': false,
				'onOpen': function ($this) {
					$.ajax({
						url: url,
						xhrFields: {
							withCredentials: true
						},
						crossDomain: true,
						cache: false,
						timeout: 15000,
						type: 'GET',
						data: params,
						dataType: 'jsonp',
						contentType: 'application/json',
						success: function (response) {
							if (response.hasexception) {
								var html = '<div class="ancGrid ancGridPadded"><div class="ancCol w100"><p class="icon iconWarning">' + PersonCard.text.addPersonErrorText + '</p></div></div>';
								$.modal.showLoading(false);
								$this.html(html);
							} else {
								/* Load modal content */
								$.when(loadCacheFiles(response))
									.done(function () {
										AddPerson.cacheLoaded = true;
										/* When cache files are loaded, show Modal. */
										$.modal.showLoading(false);
										$.modal.resize(760);
										/* Load form onto the DOM */
										/* If a name is supplied, build special modal header */
										if (response.name) {
											var profileHtml = (response.imageUrl) ? '<div class="userCardImg userCardImgSquare"><img alt="' + response.title + '" src="' + response.imageUrl + '" style="vertical-align:middle;"></div>'
												: '<div class="userCardImg userCardImgSquare icon icon' + response.gender + '" role="presentation"></div>';
											var dateRangeHtml = (response.dateRange) ? '<p class="userCardSubTitle" style="font-weight:normal;">' + response.dateRange + '</p>' : '';
											$this.html(
												'<div class="modalHasTitle">' +
												'<div class="modalHeader modalHeaderUserCard"  id="addPersonModalHeader">' +
												'<div class="ancGrid full480">' +
												'<div class="ancCol">' +
												'<h4 class="modalTitle" style="margin:4px 0;">' + response.title + '</h4>' +
												'</div>' +
												'<div class="ancCol ancColUserCard hide480">' +
												'<div class="userCard userCardSize2">' +
												profileHtml +
												'<div class="userCardContent">' +
												'<h5 class="userCardTitle">' + response.name + '</h5>' +
												dateRangeHtml +
												'</div>' +
												'</div>' +
												'</div>' +
												'</div>' +
												'</div>' +
												response.html +
												'</div>'
											);
										} else {
											$this.html(
												'<div class="modalHasTitle">' +
												'<div class="modalHeader">' +
												'<h4 class="modalTitle">' + response.title + '</h4>' +
												'</div>' +
												response.html +
												'</div>'
											);
										}
										AddPerson.apmCallback = (apmCallback !== undefined) ? apmCallback : AddPerson.apmDefCallback;
										if (typeof (window.AddPersonModalInit) === 'function') {
											if ($Ap) {
												$Ap.APMAutoCompleteDates = window.PersonCard.autoCompleteDates;
											}
											new window.AddPersonModalInit(tid, pid, args.history, AddPerson.apsCallback, "m");
										}
									})
									.fail(function (file) {
										$this.html(response.html);
										if (window && window.console) {
											console.error('AddPerson: Unable to load' + file + '.');
										}
									});
							}
						},
						error: function () {
							$.modal.showLoading(false);
							$this.html('<div class="ancGrid ancGridPadded"><div class="ancCol w100"><p class="icon iconWarning">' + PersonCard.text.addPersonErrorText + '</p></div></div>');
						}
					});
				},
				'$trigger': trigger
			});
		},
		Add: function (tid, pid, args, onCloseCallback) {
			if ($.modal !== undefined) {
				window.closeCallouts();
			}
			new AddPerson.Modal(tid, pid, args, onCloseCallback, 'add');
		},
		Edit: function (tid, pid, args, onCloseCallback, trigger) {
			if ($.modal !== undefined) {
				window.closeCallouts();
			}
			if (typeof (args) === 'string') {
				args = JSON.parse(args);
			} else if (args === undefined) {
				args = {};
			}
			if (typeof (args) === 'object') {
				if (!args.otid) {
					args.otid = tid;
				}
				if (!args.opid) {
					args.opid = pid;
				}
			}
			new AddPerson.Modal(tid, pid, args, onCloseCallback, 'edit', trigger);
		}
	};
	return _addPerson;
}(jQuery));